import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, KeepAlive as _KeepAlive, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { computed } from 'vue'
import { useInsuranceStore } from '@/compositions/insurance/index'
import { usePlatformInfo } from '@/compositions/common'
import { setNFBottomOperatorBar } from '@/utils/tools'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { insranceState } = useInsuranceStore()
const { isLandscape } = usePlatformInfo()
const aliveIncludeItem = computed(() => {
  return insranceState.aliveIncludeItem
})

// 设置底部操作栏
let { setBottomHandle } = setNFBottomOperatorBar()
setBottomHandle()

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(isLandscape) ? 'landscape-wrap' : 'insurance-wrap')
  }, [
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component }) => [
        (_openBlock(), _createBlock(_KeepAlive, { include: _unref(aliveIncludeItem) }, [
          (_openBlock(), _createBlock(_resolveDynamicComponent(Component)))
        ], 1032, ["include"]))
      ]),
      _: 1
    })
  ], 2))
}
}

})